
import {defineComponent} from "vue";

export default defineComponent({
  name: "ButtonSide",
  props: {
    isCollapsed: {
      type: Boolean,
      required: true
    }
  }
});
